import { StringHelper } from "../../../../utilities/contracts/string-helper";

export class MeasureDosDateRange {
  measureCode?: string;
  dosStartDate?: string;
  dosEndDate?: string;

  constructor(options: Partial<MeasureDosDateRange> = {}) {
    this.measureCode = StringHelper.clean(options.measureCode);
    this.dosStartDate = StringHelper.clean(options.dosStartDate);
    this.dosEndDate = StringHelper.clean(options.dosEndDate);
  }
}
